import { BadgeOption } from "./types";

export const formatPrice = (price: number) => {
  return new Intl.NumberFormat("ko-KR").format(price);
};

export const getBadgeLabel = (
  badgeValue: string,
  badgeOptions: BadgeOption[]
) => {
  const badge = badgeOptions.find((b) => b.value === badgeValue);
  return badge?.label || badgeValue;
};

export const badgeOptions: BadgeOption[] = [
  { value: "추천", label: "추천" },
  { value: "체험상품", label: "체험상품" },
  { value: "픽드롭 패키지", label: "픽드롭 패키지" },
  { value: "독 피트니스", label: "독 피트니스" },
];
